import type { IFilterView } from "@bbj-types/user";
import { useCallback } from "react";
import { axiosUserV2 } from "./axios";

export type TPostUserFilterViewBody = Omit<IFilterView, "_id" | "teams">;

export const usePostUserFilterView = () => {
  const [state, execute, cancel] = axiosUserV2<string, TPostUserFilterViewBody, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: TPostUserFilterViewBody) => {
      return execute({
        url: "/filterView",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
